import { isValidElement } from 'react';
export default ((element, Component) => /*#__PURE__*/isValidElement(element) && (typeof Component === 'string' ? isAxiomComponent(element.type) && element.type.typeRef === Component : element.type === Component));
export function isAxiomComponent(componentConstructor) {
  return !['symbol', 'string'].includes(typeof componentConstructor) && 'typeRef' in componentConstructor && typeof componentConstructor.typeRef === 'string';
}